import { Button as pButton } from "primereact/button";
import React, { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import NoContent from "../../../assets/vectors/NoContent.webp";
import { GetMyNotices } from "../../../services/NoticeService";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { getMyProfile } from "../../../features/profile/profileSlice";
import { GetCompanies } from "../../../services/CompanyService";
const ManageSellNotices = () => {
  const [data, setData] = useState([]);
  const [getHasCompany, setHasCompany] = useState(false);
  const navigate = useNavigate();
  const myProfile = useSelector(getMyProfile);
  useEffect(() => {
    GetMyNoticesAsync();
    getComapny();
  }, []);
  const getComapny = async () => {
    await GetCompanies().then((p) =>
      setHasCompany(p.data.data.length === 0 ? false : true)
    );
  };
  const GetMyNoticesAsync = async () => {
    try {
      const data = await GetMyNotices(0);
      setData(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container">
      <Button
        disabled={!getHasCompany}
        onClick={() => {
          navigate("/NewNotice/Sell");
        }}
        className="mt-3"
        color="success"
        variant="outlined"
        endIcon={<PostAddIcon />}
      >
        <span className="px-2">ثبت آگهی فروش</span>
      </Button>

      <hr className="mt-2" />
      {data.length > 0 ? (
        <>
          <div className=" mt-2 mb-5" style={{ textAlign: "center" }}>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  {/* <th scope="col">تصویر</th> */}
                  <th scope="col">موضوع</th>
                  <th scope="col">گروه </th>
                  <th scope="col">تاریخ ثبت</th>
                  <th scope="col"> عملیات </th>
                </tr>
              </thead>
              <tbody key={"body"}>
                {data.map((p: any) => {
                  return (
                    <tr key={p.id}>
                      {/* <td>{(p as any).title}</td> */}
                      <td>{p.title}</td>
                      <td>{(p as any).category.localizedName}</td>
                      <td>{(p as any).createdDate}</td>
                      <td>
                        <Button className="px-3 m-1">
                          <i className="fa fa-pencil" aria-hidden="true"></i>
                        </Button>
                        <Button className="px-3 m-1">
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>{" "}
        </>
      ) : (
        <>
          <div className="mt-2 mb-5" style={{ textAlign: "center" }}>
            <div style={{ display: !getHasCompany ? "block" : "none" }}>
              <div>
                <p>
                  {myProfile.firstName}
                  &nbsp; عزیز !
                </p>
              </div>
              <div>
                <p style={{ color: "maroon" }}>
                  بدون ثبت فروشگاه شما قادر به انتشار آگهی فروش نمی باشید.
                </p>
              </div>
              <div>
                <Button
                  onClick={() => navigate("/companies")}
                  variant="contained"
                  color="success"
                  size="large"
                  endIcon={<AddBusinessIcon />}
                >
                  <b className="px-2">ثبت فروشگاه</b>
                </Button>
              </div>
            </div>
            <div>
              <img src={NoContent} alt="شما تاکنون آگهی فروش منتشر نکرده اید" />
            </div>
            <div>
              <b>شما هنوز هیچ آگهی فروشی منتشر نکرده اید!</b>
            </div>
            <br />
            <div>
              <Link
                style={{ color: !getHasCompany ? "GrayText" : "" }}
                to={!getHasCompany ? "/manageSellNotices" : "/NewNotice/sell"}
              >
                هم اکنون آگهی فروش ثبت کنید
              </Link>{" "}
              {" |"} <Link to={"/manageBuyNotices"}> اعلان نیاز</Link>
            </div>
          </div>
        </>
      )}

      <hr />
    </div>
  );
};
export default ManageSellNotices;
